/**
 * FAQPage Component
 */

import './styles.scss';

import { RouteMatch } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Page from '../../../containers/Page';
import PageHeader from '../../molecules/blocks/PageHeader';
import { baseline } from '../../styles/grid';
import { FAQContent } from './content';
import FAQCategoryList from './FAQCategoryList';
import FAQView from './FAQView';

// Page Path
export const FAQPagePath = '/help/faq';
export const FAQPageSectionPath = (section: string) => `/help/faq/${section}`;

// Page Props

export interface IFAQCategory {
  id: string;
  title: string;
  questions: IFAQQuestion[];
}

export interface IFAQQuestion {
  id: string;
  question: string;
  answer: string | React.ReactNode;
}

type FAQPageProps = RouteMatch;

interface IOwnState {
  activeCategory: IFAQCategory;
}

const classes = new BEM('faq');

export default class FAQPage extends React.Component<FAQPageProps, IOwnState> {
  constructor(props: FAQPageProps) {
    super(props);

    if (!props.routeParams.id) {
      props.router.push(`${FAQPagePath}/${FAQContent[0].id}`);
    }

    this.state = {
      activeCategory: FAQContent.find(({ id }) => id === props.routeParams.id) || FAQContent[0],
    };
  }

  componentDidMount() {
    const hash = this.props.match.location.hash;
    if (hash) {
      const anchorId = hash.substr(1);
      const anchorEl = document.getElementById(anchorId);
      if (!!anchorEl) {
        const { top } = anchorEl.getBoundingClientRect();
        window.scrollTo(0, top - baseline * 15);
      }
    }
  }

  onSelectCategory = (categoryId: string) => {
    this.setState({ activeCategory: FAQContent.find(({ id }) => id === categoryId)! });
  }

  render() {
    return (
      <Page id="faq" {...classes('') }>
        <PageHeader title="Frequently Asked Questions" />
        <div {...classes('content-wrapper') }>
          <FAQCategoryList categories={FAQContent} onSelectCategory={this.onSelectCategory} />
          <FAQView data={this.state.activeCategory} />
        </div>
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/FAQ/index.tsx